import { useCallback, useState } from 'react'

import {
  resolveDossierTab,
  type DealDossierTab,
  type DealDossierTabInput,
} from '@/store/dealDossierStore'

/**
 * The dossier's open tab. A host that passes `onTabChange` controls it (the
 * Layout host keeps it in the dossier store). A host that does not — the Deal
 * Locator drawer, Intake — gets a dossier that keeps its own tab, starting on
 * `tab`; without this every tab click went to an undefined handler.
 */
export function useDossierTab(
  tabProp: DealDossierTabInput | undefined,
  onTabChange: ((tab: DealDossierTab) => void) | undefined,
): [DealDossierTab, (next: DealDossierTab) => void] {
  const [ownTab, setOwnTab] = useState<DealDossierTab>(() => resolveDossierTab(tabProp))
  const controlled = onTabChange !== undefined
  const tab = controlled ? resolveDossierTab(tabProp) : ownTab
  const changeTab = useCallback(
    (next: DealDossierTab) => {
      if (onTabChange) onTabChange(next)
      else setOwnTab(next)
    },
    [onTabChange],
  )
  return [tab, changeTab]
}
